import { z } from 'zod';
export const ANNOUNCEMENT_LEVELS = [
    { code: 'info', name: 'Informativo' },
    { code: 'warning', name: 'Aviso importante' },
    { code: 'success', name: 'Novedad' },
];
/** Mensaje de la plataforma que ven todos los usuarios (mantenimientos, novedades, cambios de Hacienda). */
export const announcementInput = z
    .object({
    message: z.string().trim().min(3, 'Escribí el mensaje').max(400),
    level: z.enum(['info', 'warning', 'success']).default('info'),
    isActive: z.boolean().default(true),
    startsAt: z.iso.datetime({ offset: true }).nullable().optional(),
    endsAt: z.iso.datetime({ offset: true }).nullable().optional(),
})
    .refine((v) => !v.startsAt || !v.endsAt || v.startsAt < v.endsAt, {
    path: ['endsAt'],
    message: 'Debe ser posterior al inicio',
});
//# sourceMappingURL=announcements.js.map